
const ContactItem = ({ contact }) => {
    const assuntos = contact.assunto ? contact.assunto.split('\n') : [];

    if (assuntos.length > 0 && assuntos[0].trim() === '') assuntos[0] = ' ';

    return (
        <div className="border-b border-gray-200 py-6 [&:last-child]:border-0 [&:last-child]:pb-0 min-w-[500px]">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-6">
                <div>
                    <p className="sm:text-xl md:text-2xl text-blue-900 font-bold mb-2">{contact.nome}</p>
                    <p className="md:text-lg text-cyan-500 font-bold max-w-60 leading-tight">{contact.cargo}</p>
                    <p className="mt-2">
                        <a href={`mailto:${contact.email}`} className="max-sm:text-xs max-md:text-sm text-neutral-600 hover:underline">
                            {contact.email}
                        </a>
                    </p>
                    {contact.telefone && (
                        <p>
                            <a
                                href={`https://wa.me/${contact.telefone.replace(/\D/g, '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="max-sm:text-xs max-md:text-sm text-neutral-600 hover:underline"
                            >
                                {contact.telefone}
                            </a>
                        </p>
                    )}
                </div>

                <div className="sm:col-span-2">
                    {assuntos.map((assunto, i) => (
                        <p
                            key={`assunto-${i}`}
                            className="mb-2 md:mb-3 max-sm:text-xs max-md:text-sm list-item [&::marker]:text-transparent"
                        >
                            {assunto}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContactItem;
